const rankings = [
  { rank: 1, title: '长安幻夜', tag: '古装', hot: '本周热度第一', change: 'up' },
  { rank: 2, title: '迷雾追踪', tag: '悬疑', hot: '新上榜', change: 'new' },
  { rank: 3, title: '声入人心', tag: '综艺', hot: '连冠3周', change: 'up' },
  { rank: 4, title: '星际远征', tag: '科幻', hot: '票房冠军', change: 'down' },
  { rank: 5, title: '那年冬天', tag: '韩剧', hot: '口碑飙升', change: 'up' },
  { rank: 6, title: '山海之间', tag: '纪录', hot: '豆瓣9.2', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新电视剧更新热度排行，看看大家都在追什么
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
            {rankings.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < rankings.length - 1 ? 'border-b border-background-200/70' : ''
                } hover:bg-background-50 transition-colors duration-200 cursor-pointer`}
              >
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                      {item.title}
                    </span>
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-sm"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>
                  )}
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">NEW</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}